function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1858 15.4846L10.0007 18.3371L4.81547 15.4846V12.4709L3.33398 11.666V16.3319L10.0007 19.9994L16.6673 16.3319V11.666L15.1858 12.4709V15.4846Z",
  fill: "#C7E8FE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0L0 5.77155V7.14969L10 13.3333L18.5714 8.0331V12.424H20V5.77155L10 0ZM17.1429 7.09747L15.7143 7.98083L10 11.5146L4.28571 7.98083L2.85714 7.09747L1.86701 6.48517L10 1.79117L18.133 6.48517L17.1429 7.09747Z",
  fill: "#C7E8FE"
});

var SvgCilEducation = function SvgCilEducation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCilEducation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cil_education.fb64f751.svg";
export { ForwardRef as ReactComponent };